import { render, staticRenderFns } from "./TeachBackModule.vue?vue&type=template&id=58503aac&scoped=true"
import script from "./TeachBackModule.vue?vue&type=script&lang=js"
export * from "./TeachBackModule.vue?vue&type=script&lang=js"
import style0 from "./TeachBackModule.vue?vue&type=style&index=0&id=58503aac&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58503aac",
  null
  
)

export default component.exports